/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoaderEffect } from "../common";
import { init, joinRoom } from "../../libs";
import { useParams } from "react-router-dom";
import { setUserDetail, setRoomDetails, setExtensionDetails, setExtensionShow, setVideoContainerSettings } from "../../reduxStore/confSlice";
import { socketConnect, addParticipant, getActiveWidget, getTimerActive } from "../../utils/socket";
import VideoContainer from "./videoContainer";
import ExtensionHandler from "../extensions/extensionHandler";
import FeaturedChatMessage from "./FeaturedChatMessage";
import { getWidgetCode, viewType } from "../../utils/util";
import { handleActiveTimer } from "../../utils/functions";
import ExtensionTimer from "../extensions/extensionTimer";

const Conference = () => {
  const screenDimension = useSelector((state) => state.conf.screenDimension);
  const localUser = useSelector((state) => state.conf.localUser);
  const roomDetail = useSelector((state) => state.conf.roomDetail);
  const extensionShow = useSelector((state) => state.conf.extensionShow);
  const featuredMsg = useSelector((state) => state.conf.featuredMsg);
  const timerExtensionShow = useSelector(
    state => state.conf.timerExtensionShow,
  );

  const [loaderEffect, setloaderEffect] = useState(true);
  const dispatch = useDispatch();
  const params = useParams();
  const conference_room = params.room.toLowerCase();
  const conferenceWithPrefix = conference_room && (conference_room?.startsWith('meetn_') || conference_room?.startsWith('rlink_') || conference_room?.startsWith('meetndev_') || conference_room?.startsWith('rlinkdev_'));
  const room = conferenceWithPrefix ? conference_room?.substring(conference_room.indexOf('_') + 1) : conference_room;
  const view = useSelector((state) => state.conf.view);
  const { viewWidth } = screenDimension;
  console.log('room', room);

  useEffect(() => {
    let token = [];
    let tmplocalUser = { ...localUser };
    Promise.all([socketConnect(room, token)])
      .then((ret) => {
        if (ret[0]?.status === 200) {
          let domain = ret[0]?.data?.domain;
          const tempRoomDetail = ret[0]?.data.room;

          init(dispatch, conference_room, domain).then(() => {
            dispatch(setRoomDetails(tempRoomDetail));
            tmplocalUser = { ...ret[0]?.data.guest };
            tmplocalUser.is_hidden = true;
            tmplocalUser.name = "Recorder";
            dispatch(setUserDetail({ ...tmplocalUser }));
            dispatch(setRoomDetails(ret[0]?.data.room));

            const {
              show_speaker_on_presentation,
              show_names_on_videos,
              hide_muted_attendees,
            } = tempRoomDetail;

            dispatch(
              setVideoContainerSettings({
                show_speaker_on_presentation,
                show_names_on_videos,
                hide_muted_attendees,
              }),
            );

            joinRoom().then(async (jid) => {
              tmplocalUser.waiting_status = "accepted";
              tmplocalUser.jid = jid;
              dispatch(setUserDetail(tmplocalUser));


              Promise.all([addParticipant(tmplocalUser)]).then((ret) => {
                setloaderEffect(false);

                let payload = { room: tempRoomDetail?.room, token_unique: tmplocalUser?.token_unique };

                getActiveWidget(payload).then((response) => {
                  if (response.status === 200) {
                    let data = response?.data.length > 0 ? response?.data[0] : {};
                    if (data && Object.keys(data).length > 0) {
                      if (data.extensionid === getWidgetCode('hide-popup')) {
                        dispatch(setExtensionShow(false));
                        dispatch(setExtensionDetails({}));
                      } else {
                        dispatch(setExtensionShow(true));
                        dispatch(setExtensionDetails(data));
                      }
                    }
                  }

                });
                getTimerActive(payload).then(response => {
                  let data = response?.data.length > 0 ? response?.data[0] : {};
                  if (data && Object.keys(data).length > 0) {
                    handleActiveTimer(data, 'timer-widget-active');
                  }
                });

              });
            });
          })

        } else if (ret[0]?.status === 422) {
          console.log("error1", ret[0]?.status);
        } else {
          console.log("error2", ret[0]?.status);
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("error");
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const galleryWrapperStyle = useMemo(() => {
    return { width: `${viewWidth}px` };
  }, [view, viewWidth]);


  return loaderEffect ? (
    <LoaderEffect />
  ) : (
    <>
      <div className="conference-wrap">
        <div className={`galleryMain ${roomDetail?.room_background !== '' ? 'room__background' : ''} lem-ext`} style={
          roomDetail?.room_background !== ''
            ? { backgroundImage: `url(${roomDetail?.room_background})` }
            : {}
        }>
          <div
            className="videoGalleryWrapper"
            style={galleryWrapperStyle}
          >
            <VideoContainer />
          </div>

          {extensionShow && <ExtensionHandler />}

          {timerExtensionShow && (
            <ExtensionTimer />
        )}
          {Object.keys(featuredMsg).length > 0 && featuredMsg.id !== '' && (
            <FeaturedChatMessage />
          )}

          {roomDetail?.overlay_image && (
            <div className="position-absolute bottom-3 right-3 w-10">
              <img
                src={roomDetail?.overlay_image}
                alt="Brand"
                className="overlay-img"
              />
            </div>
          )}

        </div>

      </div>
    </>
  );
};
export default Conference;
